import moment from 'moment';

export const getFullName = (finalCustomer, options = { useFullName: true }) => {
  if (!finalCustomer || typeof finalCustomer !== 'object') return '';
  if ((options.useFullName || !finalCustomer.name) && finalCustomer.firstName) {
    return [finalCustomer.firstName, finalCustomer.secondName, finalCustomer.lastName, finalCustomer.secondLastName]
      .filter(Boolean)
      .join(' ');
  }
  return finalCustomer.name;
};

export const formatBirthDate = (birthDate, format = 'DD-MM-YYYY') => {
  const birth = new Date(birthDate);
  if (birth.toString() === 'Invalid Date') return birthDate;
  return moment(birthDate).format(format);
};

export const getAgeFromBirthDate = (birthDate) => {
  const startDate = moment(birthDate);
  const endDate = moment();
  if (!startDate.isValid() || startDate > endDate) {
    return startDate;
  }

  const years = endDate.diff(startDate, 'years');

  const dateAfterYears = startDate.add(years, 'years');
  const months = endDate.diff(dateAfterYears, 'months');

  const dateAfterMonths = dateAfterYears.add(months, 'months');
  const days = endDate.diff(dateAfterMonths, 'days');

  return { years, months, days };
};

export const getPhone = (finalCustomer) => {
  if (typeof finalCustomer !== 'object') return '';
  if (finalCustomer.mobilePhone) {
    const indicativePlusMobilePhone = finalCustomer.mobilePhoneIndicative
      ? `(${finalCustomer.mobilePhoneIndicative}) ${finalCustomer.mobilePhone}`
      : `${finalCustomer.mobilePhone}`;

    return [indicativePlusMobilePhone, finalCustomer.phone].filter(Boolean).join(' - ');
  }
  return finalCustomer.phone;
};

export const getFinalCustomerChatTitle = (data) => {
  return [data.finalCustomerDisplayedName?.trim(), data.finalCustomerPhoneNumber?.trim()].filter(Boolean).join(' - ');
};
